<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
h2 {
  /* color: orange; */
  padding-bottom: 3rem;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983 !important;
}
.panoviewer {
  height: 100%;
}
.modalx-bg {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.modalx {
  font-family: "Lora", serif;
  background-color:#607025 !important;
  color: white;
  overflow-x: clip;
  margin: auto;
  padding: 2rem;
  width: 60vw;
  max-height: 80%;
  overflow-y: scroll;
  transition: all 1s linear;
}
.modalx >>> a{
  color: floralwhite;
}
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.blurred {
  filter: blur(5px);
  -webkit-filter: blur(5px);
  transition: all 1s linear;
}
.thumb {
  width: 5%;
  height: 5%;
  margin: 5px 5px 5px 5px;
}
.mainphoto {
  width: 40%;
  height: 40%;
}
p {
  text-align: left;
}
@media only screen and (max-width: 800px) {
  .modalx {
    width: 80vw;
    padding: 1.8rem;
  }
  h2 {
    padding-bottom: 1rem;
  }
  .mainphoto {
    width: 45%;
    max-height: 60%;
    margin: auto;
    display: block;
  }
}
</style>

<template>
  <div>
    <div id="viewer" class="panoviewer" :class="{blurred: viewSingle}">
    </div>
    <div v-show="viewSingle" @click="closeModal" class="modalx-bg">
      <div v-on:click.stop="()=>{}" class="modalx" ref="modalx">
        <span @click="closeModal" class="close">&times;</span>
        <MemoryGame 
          v-if="markTemplate == 'game' && viewSingle" 
          :markId="currentHotspot"
          :title="titles[this.currentHotspot]"
          @onFinishGame="onMiniGameFinished" 
          @onStatsChanged="statsChanged"
        />

        <GameM1 
          v-if="markTemplate == 'mark4Content'" 
          @onImageClicked="imageClicked"
        />
        <GameM2
          v-if="markTemplate == 'mark3Content'" 
          @onImageClicked="imageClicked"
        />
        <GameM3
          v-if="markTemplate == 'mark5Content'" 
          @onImageClicked="imageClicked"
        />
        <GameM4
          v-if="markTemplate == 'mark2Content'" 
          @onImageClicked="imageClicked"
        />
        <GameM5
          v-if="markTemplate == 'mark1Content'" 
          @onImageClicked="imageClicked"
        />
        <InfoBanner
          v-if="markTemplate == 'infoBanner'"
        />

        <img class="thumb" v-show="images.length > 1" v-for="(image, i) in images" :key="image" :src="image" @click="imageIndex = i">
        <vue-gallery-slideshow :images="images" :index="imageIndex" @close="imageIndex = null"></vue-gallery-slideshow>
      </div>
    </div>
  </div>
</template>

<script>
import { Viewer } from "photo-sphere-viewer";
import ViewerMarkers from "photo-sphere-viewer/dist/plugins/markers";
import MemoryGame from "@/components/MemoryGame.vue";

import Salas from "@/assets/SalasGameConf";

import VueGallerySlideshow from "vue-gallery-slideshow";
import GameM1 from "@/components/gameRoom/GameM1.vue";
import GameM2 from "@/components/gameRoom/GameM2.vue";
import GameM3 from "@/components/gameRoom/GameM3.vue";
import GameM4 from "@/components/gameRoom/GameM4.vue";
import GameM5 from "@/components/gameRoom/GameM5.vue";
import InfoBanner from "@/components/gameRoom/InfoBanner.vue";

export default {
  name: "Game",
  data() {
    return {
      viewer: "",
      marks: Salas.lobby.marks,
      imgurl1: Salas.lobby.pano,
      panoramadata: {
        left  : "game/sala/vacia/IZQUIERDA.png",
        front : "game/sala/vacia/FRENTE.png",
        right : "game/sala/vacia/DERECHA.png",
        back  : "game/sala/vacia/ATRAS.png",
        top   : "game/sala/vacia/TECHO.png",
        bottom: "game/sala/vacia/PISO.png"
      },
      loading_img: "../../static/pano/assets/photosphere-logo.gif",
      photosphere: "photosphere",
      imageLoaded: false,
      audios: [],
      markTemplate: "",
      images: [],
      viewSingle: false,
      currentHotspot: "",
      titles: {
        mark1: "¡Encuentra el cuadro extraviado!",
        mark2: "¡Encuentra el objeto extraviado!",
        mark3: "¡Encuentra el cuadro extraviado!"
      },
      imageIndex: null,
      resolvedGames: []
    };
  },
  computed:{
    gamePercentage() {
      // Cambiar la cantidad entre la que se divide con el numero de minijuegos
      return this.resolvedGames.length / 3.0;
    }
  },
  components: {
    VueGallerySlideshow,
    MemoryGame,
    GameM1,
    GameM2,
    GameM3,
    GameM4,
    GameM5,
    InfoBanner
  },
  props: {
    msg: String
  },
  methods: {
    imageClicked(idx) {
      this.imageIndex = idx;
    },
    closeModal() {
      this.viewSingle = false;
      this.markTemplate = "";
    },
    statsChanged(stats) {
      console.log("Game Stats:", stats);
    },
    onMiniGameFinished() {
      const marksMap = {
        mark1: this.gameFinishedMark1,
        mark2: this.gameFinishedMark2,
        mark3: this.gameFinishedMark3
      };

      const currmark = marksMap[this.currentHotspot] ?? "";
      if (!currmark) return;

      currmark();
      this.resolvedGames.push(this.currentHotspot);
      this.viewer.plugins.markers.hideMarker(this.currentHotspot);
      if (!this.currentHotspot.includes("Content")) { this.viewer.plugins.markers.showMarker(`${this.currentHotspot}Content`); }
      // this.viewer.setOption("caption", this.gamePercentage);

      this.allGamesIsFinished();
      this.viewer.setPanorama(this.panoramadata, { longitude: 0, latitude: 0, zoom: 40 })
        .then(() => {
          console.log("panorama updated");
        });
      this.viewSingle = false;
    },
    gameFinishedMark1() {
      if (this.resolvedGames.indexOf("mark2") >= 0) { this.panoramadata.right = "game/sala/final/DERECHA_CUADRO_PENACHO.png"; }
      else { this.panoramadata.right = "game/sala/final/DERECHA_CUADRO.png"; }

      this.viewer.plugins.markers.hideMarker("pinmark5");
      this.viewer.plugins.markers.hideMarker("pinmark6");
    },
    gameFinishedMark2() {
      if (this.resolvedGames.indexOf("mark1") >= 0) { this.panoramadata.right = "game/sala/final/DERECHA_CUADRO_PENACHO.png"; }
      else { this.panoramadata.right = "game/sala/final/DERECHA_PENACHO.png"; }

      this.viewer.plugins.markers.hideMarker("pinmark1");
      this.viewer.plugins.markers.hideMarker("pinmark2");
    },
    gameFinishedMark3() {
      this.panoramadata.left = "game/sala/final/IZQUIERDA_CUADRO.png";
      this.viewer.plugins.markers.hideMarker("pinmark3");
      this.viewer.plugins.markers.hideMarker("pinmark4");
    },
    allGamesIsFinished() {
      if (this.resolvedGames.length < 3) { return; }
      this.viewer.plugins.markers.hideMarker("pinmark1");
      this.viewer.plugins.markers.hideMarker("pinmark2");
      this.viewer.plugins.markers.hideMarker("pinmark3");
      this.viewer.plugins.markers.hideMarker("pinmark4");
      this.viewer.plugins.markers.hideMarker("pinmark5");
      this.viewer.plugins.markers.hideMarker("pinmark6");
      this.panoramadata = {
        left  : "game/sala/final/IZQUIERDA.png",
        front : "game/sala/final/FRENTE.png",
        right : "game/sala/final/DERECHA.png",
        back  : "game/sala/final/ATRAS.png",
        top   : "game/sala/final/TECHO.png",
        bottom: "game/sala/final/PISO.png"
      };
    }
  },
  mounted() {
    // console.log(M);
    this.viewer = new Viewer({
      container: document.querySelector("#viewer"),
      panorama: this.panoramadata,
      defaultZoomLvl: 40,
      defaultLat: "0deg",
      defaultLong: "180deg",
      loadingTxt: "Cargando...",
      size: {
        width: "100vw",
        height: "100vh"
      },
      navbar: false,
      // caption: this.gamePercentage,
      // navbar: [
      //   // "zoom",
      //   "caption",
      //   // "fullscreen",
      // ],
      plugins: [[ViewerMarkers, { markers: Salas.lobby.marks }]]
    });
    // this.viewer.plugins.markers;
    // this.viewer.on("click", (e, data) => {
    //   console.log("Clicked", data.longitude, data.latitude, data);
    // });
    // this.viewer.on("position-updated", (e, position) => {
    //   console.log(`new position is longitude: ${position.longitude} latitude: ${position.latitude}`);
    // });
    this.viewer.on("ready", (e) => {
      this.markTemplate = "infoBanner";
      this.viewSingle = true;
    });
    this.viewer.plugins.markers.on("select-marker", (e, marker) => {
      const { id = "" } = marker;
      const parts = id.split(":");
      const [cmd = "mark", arg = null] = parts;
      // console.log("Markers:", id, cmd, arg);
      if (cmd === "exit" && arg) {
        console.log("Exiting to", arg);
        this.$router.replace( { name: "view360", params: { sala: arg } });
        return;
      }

      if (id.startsWith("pinmark")) { return; }

      const [currentMark = {}] = Salas.lobby.marks.filter(m => m.id === id);
      const { info = {} } = currentMark;
      const { template = "", images = [], audios = [] } = info;

      this.audios = audios;
      this.markTemplate = template === "" ? "game" : template;
      this.images = images;

      this.currentHotspot = id;
      this.viewSingle = true;

      this.$nextTick(() => {
        this.$refs.modalx.scrollTop = 0;
      });
    });
  }
};
</script>
